export enum EDesignType {
  BETA = 'beta',
  STABLE = 'stable',
}
